import React from 'react';

import LandingPage from '../../pages/LandingPage';

import Feed from '../../components/Feed';
import Head from '../../components/Head';
import { Title } from '../../helper/consts';

// import { CircularProgress } from 'material-ui';

import Fade from 'material-ui/transitions/Fade';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};

export default class Home extends React.Component {
	render() {
		return (
			<React.Fragment>
				<Head title={`${Title}`} />
				<div
					id={this.props.loggedIn ? 'loggedInBody' : null}
					className={this.props.loggedIn ? 'body' : 'loggedOutBody'}
				>
					{this.props.authLoading && (
						<div id="loadingLogo" style={style.loading}>
							Ѳ
						</div>
					)}
					{!this.props.authLoading &&
						!this.props.loggedIn && (
							<Fade in={!this.props.authLoading && !this.props.loggedIn}>
								<LandingPage />
							</Fade>
						)}
					{!this.props.authLoading &&
						this.props.loggedIn && (
							<Feed
								jobs={this.props.jobs}
								myJobs={this.props.myJobs}
								myJobsLoading={this.props.myJobsLoading}
								adminLoading={this.props.adminLoading}
								admin={this.props.admin}
								profile={this.props.user}
								skills={this.props.skills}
								uid={this.props.uid}
								invited={this.props.invited}
								user={this.props.user}
							/>
						)}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js